import {Brick, registerBrick} from 'olympe';

export default class UpdateGatewayFilter extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} body
     * @param {ListDef} updates
     * @param {ListDef} filters
     * @param {function()} forwardEvent
     * @param {function(string)} setBody
     */
    update ($, [body, updates, filters], [forwardEvent, setBody]) {
        let objectBody = {};

        if (body !== '{}' && Boolean(body)) {
            // body contains some data
            objectBody = JSON.parse(body);
        }

        let newObj = {};
        if (updates && Array.isArray(updates) && updates.length !== 0) {
            newObj.update = [...updates];
        }

        if (filters && Array.isArray(filters) && filters.length !== 0) {
            newObj.filters = [...filters];
        }

        objectBody.data = [{...newObj}];
        setBody(JSON.stringify(objectBody));
        forwardEvent();
    }
}

registerBrick('018d8752fe12fd15c001', UpdateGatewayFilter);
